import React from 'react';
import VehicleStatusCard from './StatusCards/VehicleStatusCard';
import UserStatusCard from './StatusCards/UserStatusCard';
import DamageStatusCard from './StatusCards/DamageStatusCard';
import ReminderStatusCard from './StatusCards/ReminderStatusCard';

const StatusCard = (props) => {
    if (props.type == 'vehicle') {
        return (
            <VehicleStatusCard  {...props}/>
        )
    } else if (props.type == 'user') {
        return (
            <UserStatusCard {...props}/>
        )
    } else if (props.type == 'user-active') {
        return (
            <UserStatusCard {...props} active/>
        )
    } 
    else if (props.type == 'damage') {
        return (
            <DamageStatusCard {...props}/>
        )
    } 
    else if (props.type == 'reminder') {
        return (
            <ReminderStatusCard {...props}/>
        )
    } 
    else {
        return null;
    }
}

export default StatusCard;